export const scrollToId = (id, offset = 0, duration = 200) => {
  try {
    var element = document.getElementById(id);
    if (element) {
      scrollTo(findPos(element) + offset, duration, window);
    } else {
      console.error("no element");
    }
  } catch (e) {
    console.error("scrollToId", e);
  }
};

export const scrollToIdX = (id, offset = 0) => {
  setTimeout(() => {
    try {
      var element = document.getElementById(id);
      if (element) {
        const scrollEl = findAncestor(element, "scrollEl");
        scrollToX(findPosLeft(element) + offset, 200, scrollEl);
      }
    } catch (e) {}
  }, 100);
};

function findPos(obj) {
  let top = 0;
  if (obj.offsetParent) {
    do {
      top += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return top;
  }
}

function findPosLeft(obj) {
  let left = 0;
  if (obj.offsetParent) {
    do {
      left += obj.offsetLeft;
    } while ((obj = obj.offsetParent));
    return [left];
  }
}

function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

export const scrollToTicket = ticketIndex => {
  try {
    var parentElement = document.getElementById("ticket-picker");
    const elementX = (window.innerWidth - 48) * ticketIndex;
    scrollToX(elementX, 200, parentElement);
  } catch (err) {}
};

export const scrollToNextX = (ticketIndex, elementId) => {
  try {
    var parentElement = document.getElementById(elementId);
    const elementX = window.innerWidth * ticketIndex;
    scrollToX(elementX, 200, parentElement);
  } catch (err) {}
};

export const scrollTo = (elementY, duration, scrollEl) => {
  var startingY = scrollEl.scrollTop;
  var diff = elementY - startingY;
  var start;

  if (!window.requestAnimationFrame) {
    scrollEl.scrollTo(elementY, 0);
    return;
  }
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    const time = timestamp - start;
    const percent = duration === 0 ? 100 : Math.min(time / duration, 1);
    scrollEl.scrollTo(startingY + diff * percent, 0);
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};

export const scrollToX = (elementX, duration, scrollEl) => {
  var startingX = scrollEl.scrollLeft;
  var diff = elementX - startingX;
  var start;

  if (!window.requestAnimationFrame) {
    scrollEl.scrollTo(elementX, 0);
    return;
  }
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    const time = timestamp - start;
    const percent = duration === 0 ? 100 : Math.min(time / duration, 1);
    scrollEl.scrollTo(startingX + diff * percent, 0);
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};



// WEBPACK FOOTER //
// ./utils/ScrollTo.js